(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('IncidentDepartment', IncidentDepartment);

    IncidentDepartment.$inject = ['$resource'];

    function IncidentDepartment ($resource) {
        var resourceUrl =  'api/incident-departments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/incident-departments/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();
